export default "10,Tidlig vinterland\n9,Senvinterland\n"